import React, { useState, useEffect, useRef, memo } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Logo from "../../assets/images/tugo-logo-light.svg";
import bcorp from "../../assets/images/b-corp.png";
import styles from "../Layout.module.css";
import payImg from "../../assets/images/payment-accept.png";
import twittericon from "../../assets/images/twitter-wt.png";
import { useTranslation, Trans } from "react-i18next";
import { setStorage, getStorage } from "../../utilityfunctions";

const Footer = () => {
  const [height, setHeight] = useState(0);
  const [visible, setVisible] = useState(false);
  const heightRef = useRef();
  const [cookieshow, setcookieshow] = useState(true);
  const [cookieAccepted, setcookieAccepted] = useState([]);

  const getSize = () => {
    let newHeight = heightRef.current.clientHeight;
    setHeight(newHeight);
  };
  const { t } = useTranslation(); // Used Translation file

  const { sitesettings, status, promotions, promotionStatus } = useSelector((state) => state.sitesettings);
  const { offerProductList } = useSelector((state) => state.products);
  const { userActive: userDetails, activeStatus } = useSelector(
    (state) => state.users
  );
  let hasSettings = false;
  let hasPromotions = false;

  if (status === "succeeded") {
    hasSettings =
      sitesettings && sitesettings?.data && sitesettings?.data.length > 0;
  }

  if (promotionStatus === "succeeded") {
    hasPromotions =
      promotions && promotions?.data && promotions?.data.length > 0;
  }

  useEffect(() => {
    getSize();

    window.addEventListener("resize", getSize);
    const cookieValue = getStorage("cookie_accepted");
    if (cookieValue) {
      setcookieAccepted(cookieValue);
      setcookieshow(false);
      document.body.classList.remove("cookies-on");
    }
    return () => {
      window.removeEventListener("resize", getSize);
    };
  }, []);

  // useEffect(() => {
  //   document.body.style.setProperty("--padBottom", height + "px");
  // }, [height]);

  const scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 500) {
      setVisible(true);
    } else if (scrolled <= 500) {
      setVisible(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", toggleVisible);
    return () => {
      window.removeEventListener("scroll", toggleVisible);
    };
  }, []);

  const cookiePopClose = (e) => {
    e.preventDefault();

    var cookieChecked = getStorage("cookie_accepted");

    if (
      cookieChecked == "" ||
      cookieChecked === null ||
      cookieChecked == "null"
    ) {
      setStorage("cookie_accepted", "Yes");

      setcookieAccepted("Yes");
      setcookieshow(false);

      document.body.classList.remove("cookies-on");
    }
  };

  const showCookie = (e) => {
    e.preventDefault();
    setcookieshow(false);
    document.body.classList.remove("cookies-on");
  };
  const currentDate = new Date();

  return (
    <>
      <footer ref={heightRef}>
        <div className="sm-container">
          <div className={styles.footerWrap}>
            <div className={styles.footerLeft}>
              <div className={styles.footLogo}>
                <Link to="/" className={styles.logo} title="TUGO">
                  <img src={Logo} alt="Tugo Logo" />
                </Link>
                <div className={styles.fotPayOpt}>
                  <p>{t("we_accept")}</p>
                  <img src={payImg} alt="Payment Option" className="payImg" />
                </div>
              </div>

              {/* <div className={styles.footAdr}>
                <p>
                  <Trans i18nKey="address" components={{ br: <br></br> }} />
                </p>
              </div> */}

              <div className={styles.footLinks}>
                <ul className={styles.footnav}>
                  <li>
                    <a href="/product/pizza">{t("pizza_text")}</a>
                  </li>
                  <li>
                    <a href="/product/pasta-rice-noodle-sauces">
                      {t("pasta_text")}
                    </a>
                  </li>
                  {(userDetails?.data?.accountPriceListId != 'TRIP' && userDetails?.data?.accountPriceListId != 'DUKE' && userDetails?.data?.accountPriceListId != 'DUKE P') && 
                  (<li>
                    <a href="/product/burrito">{t("burrito_text")}</a>
                  </li>)}
                  {activeStatus === "succeeded" && userDetails?.data?.showProductInfo !== 'No' && <li>
                    <Link to="/productinfo">{t("products_info")}</Link>
                  </li>}
                  {offerProductList != undefined &&
                    offerProductList.length > 0 && (
                      <li>
                        <Link to="/offerinfo">{t("special_offertxt")}</Link>
                      </li>
                    )}
                    {getStorage("isLoggedIn") && promotions?.data?.length > 0 && (userDetails?.data?.accountPriceListId != 'TRIP' && userDetails?.data?.accountPriceListId != 'DUKE' && userDetails?.data?.accountPriceListId != 'DUKE P') && (
                        <li>
                        <Link
                          to="/monthlypromotions"
                          title={t("monthly_promotions_txt")}
                        >{t("monthly_promotions_txt")}
                        </Link>
                      </li>
                       )} 
                </ul>
                <ul className={styles.footnav}>
                  <li>
                    <a target="_blank" href="https://www.tugo.co.uk/cookie-policy">
                      {t("cookies_txt")}
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.tugo.co.uk/privacy-policy"
                    >
                      {t("privacy_txt")}
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.tugo.co.uk/terms-and-conditions"
                    >
                      {t("terms_txt")}
                    </a>
                  </li>
                  {getStorage("isLoggedIn") && promotions?.data?.some(promo => promo.InDownloads) && (userDetails?.data?.accountPriceListId != 'TRIP' && userDetails?.data?.accountPriceListId != 'DUKE' && userDetails?.data?.accountPriceListId != 'DUKE P') && (<li>
                    <Link to="/downloads">{t("download_txt")}</Link>
                  </li>)
                  }
                  <li>
                    <a target="_blank" href="https://www.tugo.co.uk/get-in-touch">
                      {t("contact_txt")}
                    </a>
                  </li>
                  {
                    (getStorage("isLoggedIn")) ? (<li className={styles.postFeed}>
                      <Link to="https://forms.office.com/e/thYAMJxKTE" target="_blank">
                        {t("post_your_feedback_txt")}
                      </Link>

                    </li>) : ''


                  }

                </ul>
              </div>

              <div className={styles.bcorpLogo}>
                  <img src={bcorp} alt="bCorp Logo" />
              </div>
            </div>
            <div className={styles.footerRight}>
            <div className={styles.footAdr}>
                <p>
                  <Trans i18nKey="address" components={{ br: <br></br> }} />
                </p>
              </div>
              <div className={styles.footlAdlink}>
              <span className={styles.link}>
                <Link to={`tel: ${t("telephone_text")}`}>
                  <i className="fa fa-phone" aria-hidden="true"></i>{" "}
                  {t("telephone_text")}
                </Link>
              </span>
              <span className={styles.link}>
                <Link to={`mailto: ${t("email_text")}`}>
                  <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
                  {t("email_text")}
                </Link>
              </span>
              <span className={styles.link}>
                <a href={"https://www.tugo.co.uk"}
                  target="_blank">
                  <i className="fa fa-globe" aria-hidden="true"></i>{" "}
                  www.tugo.co.uk
                </a>
              </span>
              </div>
              
            </div>
          </div>

          <div className={styles.footerCopy}>
            <div className={styles.CopyTxt}>
              {hasSettings ? (
                <p> {sitesettings?.data[0].copyrightText} </p>
              ) : (
                <p>
                  <Trans
                    i18nKey="copyrights_txt"
                    values={{ year: currentDate.getFullYear() }}
                  />
                </p>
              )}
            </div>
            <div className={styles.footSocial}>
              {hasSettings && (
                <ul>
                  {sitesettings?.data[0].linkedinURL !== "" && (
                    <li>
                      <a
                        href={
                          sitesettings?.data[0].linkedinURL !== ""
                            ? sitesettings?.data[0].linkedinURL
                            : ""
                        }
                        target="_blank"
                      >
                        <i className="fa fa-linkedin"></i>
                      </a>
                    </li>
                  )}

                  {sitesettings?.data[0].instagramURL !== "" && (
                    <li>
                      <a
                        href={
                          sitesettings?.data[0].instagramURL !== ""
                            ? sitesettings?.data[0].instagramURL
                            : ""
                        }
                        target="_blank"
                      >
                        <i className="fa fa-instagram"></i>
                      </a>
                    </li>
                  )}

                  {sitesettings?.data[0].facebookURL !== "" && (
                    <li>
                      <a
                        href={
                          sitesettings?.data[0].facebookURL !== ""
                            ? sitesettings?.data[0].facebookURL
                            : ""
                        }
                        target="_blank"
                      >
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                  )}

                  {sitesettings?.data[0].youtubeURL !== "" && (
                    <li>
                      <a
                        href={
                          sitesettings?.data[0].youtubeURL !== ""
                            ? sitesettings?.data[0].youtubeURL
                            : ""
                        }
                        target="_blank"
                      >
                        <i className="fa fa-youtube-play"></i>
                      </a>
                    </li>
                  )}

                  {sitesettings?.data[0].twitterURL !== "" && (
                    <li className="twitter-icon">
                      <a
                        href={
                          sitesettings?.data[0].twitterURL !== ""
                            ? sitesettings?.data[0].twitterURL
                            : ""
                        }
                        target="_blank"
                      >
                        <img src={twittericon} />
                        {/* <i className="fa fa-twitter"></i> */}
                      </a>
                    </li>
                  )}
                </ul>
              )}
            </div>
          </div>
        </div>



        <div
          className={visible ? "scrolltop show" : "scrolltop"}
          id="scrollbutton"
          onClick={scrollTop}
        >
          <a className="disbl_href_action" title="Scroll to Top">
            <span>
              <i className="fa fa-angle-double-up ars"></i>
              <i className="fa fa-angle-up ars1"></i>
              <i className="fa fa-angle-up ars2"></i>
            </span>
          </a>
        </div>
      </footer>

      {cookieAccepted !== "Yes" && cookieshow === true && (
        <div className="cookie-bar">
          <a className="cookie-close" onClick={(e) => showCookie(e)} title="Close"></a>
          <p>
            <Trans
              i18nKey="accept_cookietxt"
              components={{
                a: (
                  <a href="https://www.tugo.co.uk/cookie-policy" target="_blank" />
                ),
              }}
            />
            <a title={t("cookie_btntxt")}
              className="button cookie-btn"
              onClick={(e) => cookiePopClose(e)}
            >
              {t("cookie_btntxt")}
            </a>
          </p>
        </div>
      )}

    </>
  );
};
export default memo(Footer);
